import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export const Footer = () => {
  const [modalType, setModalType] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="py-12 bg-[#050508] border-t border-white/5" data-id="element-46">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-47">
          <div className="flex flex-col items-center gap-6" data-id="element-48">
            {/* Legal Links */}
            <nav className="flex items-center gap-6 md:gap-8" data-id="element-49">
              <button onClick={() => setModalType('privacy')} className="font-mono text-xs md:text-sm uppercase tracking-widest text-gray-500 hover:text-brand-red transition-colors" data-id="element-50">
                Privacidad
              </button>
              <span className="text-gray-700" data-id="element-51">·</span>
              <button onClick={() => setModalType('terms')} className="font-mono text-xs md:text-sm uppercase tracking-widest text-gray-500 hover:text-brand-red transition-colors" data-id="element-52">
                Términos
              </button>
            </nav>

            <div className="w-12 h-px bg-white/10" data-id="element-53"></div>

            {/* Copyright */}
            <p className="text-gray-600 text-sm font-mono text-center" data-id="element-54">
              © {new Date().getFullYear()} El Plan de Recuperación de las 24
              Horas. Todos los derechos reservados.
            </p>

            {/* Risk disclaimer */}
            <p className="text-gray-700 text-xs max-w-2xl mx-auto text-center leading-relaxed" data-id="element-55">
              El trading conlleva un alto nivel de riesgo y puede no ser
              adecuado para todos los inversores. Los resultados pasados no
              garantizan resultados futuros.
            </p>
          </div>
        </div>
      </footer>

      <LegalModal isOpen={modalType !== null} onClose={() => setModalType(null)} type={modalType} data-id="element-56" />
    </>;
};